// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// core & communications
import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'

// HTTP Handler
import VueAxios from 'vue-axios'
import http from './http'

import targetMake from './util/targetMake'
import logReport from './util/logReport'

// Vue UI 모듈
import VTooltip from 'v-tooltip'
import VueQuillEditor from 'vue-quill-editor'
import ToggleButton from 'vue-js-toggle-button'
import VueClipboards from 'vue-clipboards'
import VueScrollTo from 'vue-scrollto'
import LiquorTree from 'liquor-tree'
import Toasted from 'vue-toasted'
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation'

// global components
import GlobalComponents from './global_components'
import GlobalEvent from './global_event'

// include all css files
import './import_script_and_css'

// vue add-ons
import {store} from './store/store'
import router from './router'

import App from './App'
import Constant from './constants/commonText'
/* eslint-disable no-new */
import {mapGetters, mapMutations} from 'vuex'

import moment from 'moment'
import eventBus from '@/event_bus'
import VuePlyr from 'vue-plyr'
import Uuid from 'vue-uuid'

import DialogPopup from '@/components/DialogPopup'
import VueAnalytics from 'vue-analytics'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import dateTimePicker from '@/components/DateTimePicker'
import datePicker from '@/components/DatePicker'
import pagination from '@/components/Pagination'
import JoditEditor from '@/components/JoditEditor'
import timePicker from '@/components/TimePicker'
import startEndTimePicker from '@/components/StartEndTimePicker'
import hoursTimePicker from '@/components/HoursTimePicker'

// google-tag
import VueGtm from 'vue-gtm'

// 쿠기모듈
import VueCookies from 'vue-cookies'

// BugReport
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'

/***
 * TODO: 버그 소진 후 도입.
 * **/
if (location.host.indexOf('localhost') === -1 && process.env.SENTRY_KEY && process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    integrations: [
      new VueIntegration({
        Vue,
        tracing: true
      }),
      new Integrations.BrowserTracing()
    ],
    maxBreadcrumbs: 10,
    tracesSampleRate: 1,
    sampleRate: 0.5
  })
}

if (window.localStorage.getItem('LOGIN_PARAM')) {
  window.localStorage.removeItem('LOGIN_PARAM')
}

Vue.use(PerfectScrollbar)
Vue.use(VTooltip)
Vue.use(VuePlyr)
Vue.use(VueScrollTo)
Vue.use(Uuid)
Vue.use(LiquorTree)

Vue.use(Toasted, {
  action: {
    icon: 'close',
    onClick: (e, toastObject) => {
      toastObject.goAway(0)
    }
  },
  position: 'top-right',
  duration: 3000
})

moment.locale('kr', {
  relativeTime: {
    future: '%s 後',
    past: '%s 前',
    s: '只今',
    ss: '%d秒',
    m: '1分',
    mm: '%d分',
    h: '1時間',
    hh: '%d時間',
    d: '1日',
    dd: '%d日',
    M: '1ヶ月',
    MM: '%dヶ月',
    y: '1年',
    yy: '%d年'
  }
})
Vue.prototype.$moment = moment
Vue.prototype.$const = Constant
Vue.prototype.$targetMake = targetMake
Vue.prototype.$logReport = logReport
if (process.env.NODE_ENV === 'production') {
  Vue.use(VueGtm, {
    id: process.env.GOOGLE_TAG,
    enabled: true,
    debug: false,
    vueRouter: router,
    trackOnNextTick: false
  })
}

Vue.use(VueAnalytics, {
  id: process.env.GOOGLE_ANALYTICS,
  router,
  autoTracking: {
    pageviewOnLoad: false
  }
})

Vue.use(Vuetify, {
  iconfont: 'mdi'
})

Vue.config.productionTip = false

Vue.use(VueAxios, http)

Object.defineProperties(Vue.prototype, {
  $eventBus: {
    get: function () {
      return eventBus
    }
  }
})

// plugins
Vue.use(Vuetify, {
  theme: store.getters.selectedTheme.theme
})

Vue.use(VueQuillEditor)
Vue.use(ToggleButton)
Vue.use(VueClipboards)
Vue.use(GlobalComponents)
Vue.use(GlobalEvent)

// cookie
Vue.use(VueCookies)
Vue.$cookies.config('5min')

Vue.filter('truncate', function (text, length, suffix) {
  return text.substring(0, length) + suffix
})

Vue.component('DialogPopup', DialogPopup)
Vue.component('dateTimePicker', dateTimePicker)
Vue.component('datePicker', datePicker)
Vue.component('pagination', pagination)
Vue.component('JoditEditor', JoditEditor)
Vue.component('timePicker', timePicker)
Vue.component('startEndTimePicker', startEndTimePicker)
Vue.component('hoursTimePicker', hoursTimePicker)
Vue.component('lottieAnimation', LottieAnimation)
new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>',
  computed: {
    ...mapGetters([
      'IS_CONNECTED',
      'IS_TICKET_CONNECTED',
      'loginId',
      'enabledCallAgent',
      'IS_CALL_CONNECTED',
      'IS_TEL_ING',
      'callMode'
    ])
  },
  watch: {
    IS_CALL_CONNECTED (val) {
      if (val) {
        this.callRetryCount = 0
      }
    }
  },
  created () {
    let style = document.createElement('link')
    style.type = 'text/css'
    style.rel = 'stylesheet'
    // style.href = `//public-common-sdk.s3.ap-northeast-2.amazonaws.com/fonts/twc${process.env.NODE_ENV === 'production' ? '' : '-dev'}.css?timestemp=${new Date().getTime()}`
    style.href = `//public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/fonts/twc.css?timestemp=${new Date().getTime()}`
    document.head.appendChild(style)
    document.addEventListener('beforeunload', this.handler)
  },
  mounted () {
    eventBus.$on('reconnect-start', () => {
      setTimeout(() => {
        console.log('再接続を試す')
        this.retryConnect()
      }, 3000)
    })
    eventBus.$on('ticket-reconnect-start', () => {
      console.log('チケットソケットの再接続を試す')
      this.retryTicketConnect()
    })
    eventBus.$on('call-reconnect-start', () => {
      if (this.IS_TEL_ING !== false) {
        console.log('コールソケットの再接続を試す')
        store.commit('CLOSE_CALL')
        this.retryCallConnect()
      }
    })
  },
  destroyed () {
    eventBus.$off('reconnect-start')
    eventBus.$off('ticket-reconnect-start')
    eventBus.$off('call-reconnect-start')
  },
  data () {
    return {ticketRetryCount: 0, interval: undefined, callRetryCount: 0, callApiRetryCount: 0}
  },
  methods: {
    ...mapMutations([
      'callApiSubScribe'
    ]),
    handler: function handler (event) {
      // TODO : 구독중인 모든 방을 unscribe 한다
    },
    retryConnect () {
      store.dispatch('connect')
    },
    retryTicketConnect () {
      setTimeout(() => {
        if (this.ticketRetryCount < 5) {
          store.dispatch('ticket_connect')
          this.ticketRetryCount += 1
        } else {
          console.log('server error')
        }
      }, 500)
    },
    retryCallConnect () {
      setTimeout(() => {
        if (this.callRetryCount < 5) {
          this.$store.dispatch('setCallAgentInfo').then(() => {
            this.$store.dispatch('call_connect')
          })
          this.callRetryCount += 1
        } else {
          if (this.callMode === 'KT') {
            eventBus.$emit('DialogPopup', {
              useDialog: true,
              messageHTML: '<dl class="txt"><dd>ネットワークがシームレスです。<br/>ユーザー要請を完了できませんでした。<br/>しばらくしてからもう一度お試しください。</dd></dl>',
              getBtnCount: 1
            })
          }
          if (this.enabledCallAgent) {
            const array = new ArrayBuffer(29)
            const buffer = new Uint8Array(array)
            store.commit('sendMessageToCallSocket', buffer)
          } else {
            console.log('server error')
          }
        }
      }, 500)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js